export default {
      id: "home_pixel-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.14f187a1.svg#home_pixel",
      toString: function () {
        return this.url;
      }
    }